import React, { FC, Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { InviteDialog, PaddedPaper } from 'components';
import { IMGIX_HOST } from 'settings';
import { useProtectedClient } from 'hooks';

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(3, 1),
    backgroundImage: `url(${IMGIX_HOST}/webapp/modal-bg.svg)`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '50% calc(50%)',
  },
  faces: {
    width: theme.spacing(13),
  },
  button: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(0.5, 3),
  },
  message: {
    fontSize: theme.typography.pxToRem(12),
  },
}));

const InviteModule: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { referral_headline, referral_message } = useProtectedClient();
  const [open, setOpen] = useState(false);

  function toggleDialog() {
    setOpen(!open);
  }

  return (
    <Fragment>
      <PaddedPaper className={classes.paper}>
        <Grid container direction="column" alignItems="center" justify="space-between">
          <Grid item xs>
            <img src={`${IMGIX_HOST}/webapp/faces.png`} alt="faces" className={classes.faces} />
          </Grid>
          <Grid item xs>
            <Typography variant="subtitle2" align="center">
              {referral_headline || t('invites:module')}
            </Typography>
          </Grid>
          <Grid item xs>
            <Typography className={classes.message} align="center" color="textSecondary">
              {referral_message || t('invites:moduleText')}
            </Typography>
          </Grid>
          <Grid item xs>
            <Button
              onClick={toggleDialog}
              className={classes.button}
              color="primary"
              variant="contained"
            >
              {t('invites:moduleButtonText')}
            </Button>
          </Grid>
        </Grid>
      </PaddedPaper>

      <InviteDialog open={open} onClose={toggleDialog} />
    </Fragment>
  );
};

export default InviteModule;
